import { useLayoutEffect, useRef, useState } from "react"

const XAXIS_PADDING_TOP = 2
const LABEL_HEIGHT = 16

function TodayTickLabel(props: any) {
  const { x, y, payload, opacity } = props
  const textRef = useRef<any>(null)
  const [shouldRender, setShouldRender] = useState(false)
  const [textWidth, setTextWidth] = useState(0)

  useLayoutEffect(() => {
    if (textRef.current) {
      setTextWidth(textRef.current.getBBox().width)
      setShouldRender(true)
    }
  }, [])

  const hPad = 3
  const rectWidth = textWidth + hPad * 2
  const centerY = y + XAXIS_PADDING_TOP

  return (
    <g style={{ opacity: shouldRender ? opacity : 0 }}>
      <rect
        fill="rgba(255, 255, 255, 0.10)"
        rx={3}
        ry={3}
        x={x - rectWidth / 2}
        y={centerY - LABEL_HEIGHT / 2}
        width={rectWidth}
        height={LABEL_HEIGHT}
      />
      <text
        ref={textRef}
        x={x}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        fill="#2CCCD3"
        fontWeight={700}
        fontSize={10}
      >
        {payload.value}
      </text>
    </g>
  )
}

const ChartXAxisTick = ({
  tickProps,
  isToday,
  dimmed,
}: {
  tickProps: any
  isToday: boolean
  dimmed: boolean
}) => {
  const opacity = dimmed ? 0.2 : 1

  if (isToday) {
    return <TodayTickLabel {...tickProps} opacity={opacity} />
  }

  const centerY = tickProps.y + XAXIS_PADDING_TOP
  return (
    <text
      x={tickProps.x}
      y={centerY}
      textAnchor="middle"
      dominantBaseline="central"
      fill="#ffffffcc"
      fontWeight={400}
      fontSize={10}
      opacity={opacity}
    >
      {tickProps.payload.value}
    </text>
  )
}

export default ChartXAxisTick
